import { createLoadingSpinnerComponent, LoadingSpinner } from '@vfde-brix/loading-spinner';

/**
 * Mount loading spinner
 * @param container
 */
export const mountLoadingSpinner = (containerId: string): LoadingSpinner | null => {
    const spinner = document.getElementById(containerId);

    return spinner && createLoadingSpinnerComponent(spinner, {
        optIsVisible: false,
        business: {},
    });
};
